import { Transforms, Editor, Element, Node } from 'slate';
import { Q as QuantumConfig } from './index-72ff421b.esm.js';
import * as Y from 'yjs';
import * as awarenessProtocol from 'y-protocols/awareness.js';
import { WebsocketProvider } from 'y-websocket';

const toggleBlock = (editor, format) => {
  const isActive = isBlockActive(editor, format);
  const isList = QuantumConfig.LIST_TYPES.includes(format);
  Transforms.unwrapNodes(editor, {
    match: n => QuantumConfig.LIST_TYPES.includes(!Editor.isEditor(n) && Element.isElement(n) && n.type),
    split: true
  });
  const newProperties = {
    type: isActive ? "paragraph" : isList ? "list-item" : format
  };
  Transforms.setNodes(editor, newProperties);
  if (!isActive && isList) {
    const block = {
      type: format,
      children: []
    };
    Transforms.wrapNodes(editor, block);
  }
};
const toogleTextAlign = (editor, alignment) => {
  const newProperties = {
    textAlign: alignment
  };
  Transforms.setNodes(editor, newProperties);
};
const toggleMark = (editor, format) => {
  try {
    const isActive = isMarkActive(editor, format);
    if (isActive) {
      Editor.removeMark(editor, format);
    } else if (format !== "highlightTransparent" && format !== "fontTransparent") {
      Editor.addMark(editor, format, true);
    }
  } catch (error) {}
};
const removeMark = (editor, format) => {
  Editor.removeMark(editor, format);
};
const isBlockActive = (editor, format) => {
  try {
    const [match] = Editor.nodes(editor, {
      match: n => !Editor.isEditor(n) && Element.isElement(n) && n.type === format
    });
    return !!match;
  } catch (error) {}
};
const isTextAligned = (editor, format) => {
  try {
    const [match] = Editor.nodes(editor, {
      match: n => !Editor.isEditor(n) && Element.isElement(n) && n.textAlign === format
    });
    return !!match;
  } catch (error) {}
};
const extractOnSelection = editor => {
  try {
    const [match] = Editor.nodes(editor, {
      match: n => !Editor.isEditor(n) && Element.isElement(n)
    });
    return match;
  } catch (error) {}
};
const isNER = (editor, format) => {
  try {
    const [match] = Editor.nodes(editor, {
      match: n => !Editor.isEditor(n) && Element.isElement(n) && n.type === "ner"
    });
    return !!match;
  } catch (error) {}
};
const isMarkActive = (editor, format) => {
  try {
    const marks = Editor.marks(editor);
    if (format.includes("highlight") || format.includes("font")) manageOverlappingStyles(editor, format, marks);
    return marks ? marks[format] === true : false;
  } catch (error) {}
};
const isMarkActiveOptimised = (editor, format, marks) => {
  var _Object$keys;
  if (marks && ((_Object$keys = Object.keys(marks)) === null || _Object$keys === void 0 ? void 0 : _Object$keys.length) > 0) try {
    if (format.includes("highlight") || format.includes("font")) manageOverlappingStyles(editor, format, marks);
    return marks ? marks[format] === true : false;
  } catch (error) {}
};
const manageOverlappingStyles = (editor, format, marks) => {
  var array = Object.keys(marks).map(function (key) {
    return {
      property: key,
      value: marks[key]
    };
  });
  for (let i = 0; i < array.length; i++) {
    const style = array[i];
    Editor.removeMark(editor, style.property);
  }
};
const validateEditorObject = editor => {
  Editor.isEditor(editor);
};
const generateStyleFromElementData = element => {
  if (!element) return {};else {
    return {
      textAlign: element.textAlign
    };
  }
};
const generateToDoStyleFromElementData = element => {
  if (!element) return {};else {
    if (element.textAlign === "left") return {
      justifyContent: "flex-start"
    };else if (element.textAlign === "right") return {
      justifyContent: "flex-end"
    };else return {
      justifyContent: element.textAlign
    };
  }
};
const generateEditorValueFromSentencesArray = sentences => {
  return sentences.map((u, i) => {
    return {
      type: i === 0 ? "title" : "paragraph",
      children: [{
        text: u
      }]
    };
  });
};
const generateRTCprovider = _ref => {
  let {
    websocketEndpoint,
    documentId,
    idToken,
    value
  } = _ref;
  const yDoc = new Y.Doc(value);
  const sharedType = yDoc.getArray("content");
  const rtcProvider = new WebsocketProvider(websocketEndpoint, documentId, yDoc, {
    connect: false,
    params: {
      token: idToken
    },
    awareness: new awarenessProtocol.Awareness(yDoc)
  });
  return [sharedType, rtcProvider];
};
function wordsCount(str) {
  return str === null || str === void 0 ? void 0 : str.split(" ").filter(function (n) {
    return n !== "";
  }).length;
}
function charactesCount(str) {
  var _str$replace, _str$replace$trim;
  return str === null || str === void 0 ? void 0 : (_str$replace = str.replace(/\s+/g, " ")) === null || _str$replace === void 0 ? void 0 : (_str$replace$trim = _str$replace.trim()) === null || _str$replace$trim === void 0 ? void 0 : _str$replace$trim.length;
}
const getSlateTextLenght = fragment => {
  const cleanedTextArray = [];
  for (let i = 0; i < fragment.length; i++) {
    const element = fragment[i];
    cleanedTextArray.push(Node.string(element));
  }
  return {
    textLength: charactesCount(cleanedTextArray.join(" ")),
    wordsCount: wordsCount(cleanedTextArray.join(" "))
  };
};
const insertTextAtSelection = (editor, text) => {
  if (!text || !editor) return;
  // If the user has a selection, insert the text at the selected position
  Transforms.insertText(editor, text);
};
var Utilities = {
  isBlockActive,
  isMarkActive,
  isMarkActiveOptimised,
  extractOnSelection,
  toggleMark,
  toggleBlock,
  generateStyleFromElementData,
  generateToDoStyleFromElementData,
  toogleTextAlign,
  isNER,
  isTextAligned,
  removeMark,
  generateRTCprovider,
  validateEditorObject,
  generateEditorValueFromSentencesArray,
  wordsCount,
  charactesCount,
  getSlateTextLenght,
  insertTextAtSelection
};

export { Utilities as U };
